var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
export const Lock = (_a) => {
    var { className, size, title = "Lock" } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({}, props, { className: classNames("gerudo-icon-lock", className, size) }),
        React.createElement("svg", { width: "120", height: "120", viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("title", null, title),
            React.createElement("path", { d: "M35 55V35C35 28.3696 37.6339 22.0107 42.3223 17.3223C47.0107 12.6339 53.3696 10 60 10C66.6304 10 72.9893 12.6339 77.6777 17.3223C82.3661 22.0107 85 28.3696 85 35V55M25 55H95C100.523 55 105 59.4772 105 65V100C105 105.523 100.523 110 95 110H25C19.4772 110 15 105.523 15 100V65C15 59.4772 19.4772 55 25 55Z", stroke: "currentColor", strokeWidth: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement("rect", { x: "56", y: "79", width: "8", height: "15", fill: "currentColor" }),
            React.createElement("circle", { cx: "60", cy: "75", r: "8", fill: "currentColor" }))));
};
export default Lock;
//# sourceMappingURL=Lock.js.map